import { render } from "./Logo.vue?vue&type=template&id=4ef0a45b&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=4ef0a45b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef0a45b"],['__file',"src/components/Logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ef0a45b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ef0a45b', __exports__)) {
    api.reload('4ef0a45b', __exports__)
  }
  
  module.hot.accept("./Logo.vue?vue&type=template&id=4ef0a45b&scoped=true", () => {
    api.rerender('4ef0a45b', render)
  })

}


export default __exports__